// extracted by mini-css-extract-plugin
export default {"td":"AmountEditRow_td__AAnKd","amount-edit-td":"AmountEditRow_amount-edit-td__m3fIF","actions-td":"AmountEditRow_actions-td__-93ZH"};